import { render, staticRenderFns } from "./AddJiFen.vue?vue&type=template&id=4a2b885f&scoped=true&"
import script from "./AddJiFen.vue?vue&type=script&lang=js&"
export * from "./AddJiFen.vue?vue&type=script&lang=js&"
import style0 from "./AddJiFen.vue?vue&type=style&index=0&id=4a2b885f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b885f",
  null
  
)

export default component.exports